export const QUICK_START_GUIDE_ACTION_TYPE = 'QSG';
export const TIPS_AND_TUTORIALS_ACTION_TYPE = 'T&T';
